import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetProductsData } from 'types/api/api-products.types';

export type ProductsSliceType = {
  products: GetProductsData.Product[];
};

export const initialState: ProductsSliceType = {
  products: [],
};

const slice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<GetProductsData.ResponseType>) => {
      state.products = action.payload.products;
    },
  },
});

export default slice.reducer;

// selectors
export const productsSelector = (state: { products: ProductsSliceType }) => state.products.products;

export const { setProducts } = slice.actions;
